import { Resource } from './resource';

export class Event extends Resource {
  sessionId: number;
  title: string;
}
